<app-action-item borderColor="var(--shade-2-color)" titleColor="#000000" backgroundColor="var(--shade-2-color)"
color="#000000" titleDictionaryKey="dd.appc_cfg_action_item.{{actionItem.id}}.name" *ngFor="let resource of resources" iconCSS="fa-camera-cctv" (click)="handleLPRFailure(resource)">
  <sc-flex [centered]="true" fitHeight>
    <img [src]="url+resource" width="100%"/>
  </sc-flex>
</app-action-item>
